import React, { useRef, useEffect } from 'react';
import paper from 'paper';

const Melt = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    let counter = 20;
    paper.setup(canvasRef.current);

    const colors = [
      'grey',
    ];

    const curves = [];

    for (let i = 0; i < colors.length; i++) {
      const curve = new paper.Path();
      curve.strokeColor = colors[i];
      curve.strokeWidth = 20;
      curve.strokeJoin = 'round';
      curve.add(new paper.Point(paper.view.center.x, 0));
      curves.push(curve);
    }

    const onMouseMove = (event) => {
      const mousePoint = event.point;
      counter += 0.05;

      for (let i = 0; i < curves.length; i++) {
        const curve = curves[i];
        curve.add(new paper.Point(mousePoint.x, mousePoint.y));
        curve.strokeWidth = counter;
        curve.opacity = 0.5;
        for (let j = 0; j < curve.segments.length; j++) {
          const segment = curve.segments[j];
          const distance = segment.point.getDistance(mousePoint);
          const bendFactor = 20 / (distance + 1);
          const direction = segment.point.subtract(mousePoint).normalize();
          segment.point = segment.point.add(direction.multiply(bendFactor));
        }
      }
    };

    paper.view.on('mousemove', onMouseMove);

    return () => {
      paper.view.off('mousemove', onMouseMove);
      paper.project.clear();
    };
  }, []);

  return <canvas ref={canvasRef} style={{ width: '100%', height: '100%' }} />;
};

export default Melt;
